<template>
  <div>
    <div class="modal-header">
      <button type="button" class="close btn-back" @click="backToDetails">
        <i class="material-icons">keyboard_backspace</i>
      </button>
      <div class="create-forum-post-header">Upload New</div>
      <button type="button" class="close btn-close" @click="closeModal">
        <img src="../../assets/cross-alt.svg" alt="close" />
      </button>
    </div>

    <div class="modal-body" style="padding-top: 4px">
      <vue-dropzone
        ref="dropzone"
        id="scenario-dropzone"
        :options="
          postType === 'scenario' ? dropOptionsScenarios : dropOptionsMedia
        "
        v-on:vdropzone-file-added="fileAdded"
        :useCustomSlot="true"
        style="min-height: 380px"
      >
        <p>Drop your files here or click to browse to add to your post.</p>
      </vue-dropzone>
      <p class="upload-warning" v-if="displayUploadWarning">
        Note: uploading a folder only searches one level deep
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {PAGES, POST_TYPES} from "@/store/createForumPostStore";
import vueDropzone from "vue2-dropzone";
import { cloneDeep } from "lodash";

const DROP_OPTIONS_SCENARIOS = {
  url: "none",
  autoProcessQueue: false,
  maxFilesize: 512, // MB
  maxFiles: 10,
  addRemoveLinks: true,
  acceptedFiles: ".isims,.ctgi,.alsi,.json",
};

const DROP_OPTIONS_MEDIA = {
  ...DROP_OPTIONS_SCENARIOS,
  acceptedFiles: ".png,.jpg,.jpe,.bmp,.gif",
};

export default {
  name: "UploadNew",
  components: {
    vueDropzone,
  },
  computed: {
    ...mapState("createForumPostStore", {
      currentPage: (state) => state.currentPage,
      postType: (state) => state.postType,
      mediaToUpload: (state) => state.mediaToUpload,
      scenariosToUpload: (state) => state.scenariosToUpload,
    }),
  },
  data() {
    return {
      dropOptionsScenarios: DROP_OPTIONS_SCENARIOS,
      dropOptionsMedia: DROP_OPTIONS_MEDIA,
      displayUploadWarning: false,
    };
  },
  methods: {
    fileAdded(file) {
      if (this.postType === POST_TYPES.Scenario)
        this.scenarioAdded(file);
      else if (this.postType === POST_TYPES.Media)
        this.mediaAdded(file);
    },
    scenarioAdded(scenario) {
      this.displayUploadWarning = false;
      if (
        scenario.hasOwnProperty("fullPath") &&
        scenario.fullPath.split("/").length > 2
      ) {
        // Too deep... ignore it
        this.$refs.dropzone.removeFile(scenario);
        this.displayUploadWarning = true;
        return;
      }

      const scenariosClone = cloneDeep(this.scenariosToUpload);
      scenariosClone.push(scenario);

      this.$store.commit(
        "createForumPostStore/setScenariosToUpload",
        scenariosClone
      );
    },
    mediaAdded(media) {
      const mediaClone = cloneDeep(this.mediaToUpload);
      mediaClone.push(media);

      this.$store.commit("createForumPostStore/setMediaToUpload", mediaClone);
    },
    backToDetails() {
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Create);
    },
    closeModal() {
      this.$store.dispatch("createForumPostStore/closeModal");
    },
  },
};
</script>

<style scoped>
.create-forum-post-header {
  color: black;
  font-weight: bold;
}
.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.modal-header {
  border: none;
  padding-top: 24px;
}

.btn-back {
  margin: -1rem 0 -1rem -1rem;
  color: var(--isim-light-icon);
}

.btn-close {
  font-size: 16px;
}
</style>
